import React, { useState, useEffect } from "react";
import axios from "./axios";
import requests from "./requests";
import "./Banner.css";

function Banner() {
  const [movie, setMovie] = useState([]);

  useEffect(() => {
    async function fetchData() {
      //axios.get(fetchUrl) がpromiseの結果が返ってくるまで次の処理が実行されない
      const req = await axios.get(requests.fetchNetflixOriginals);
      // baseURL: "https://api.themoviedb.org/3" に getの引数が組み合わされる
      setMovie(
        req.data.results[Math.floor(Math.random() * req.data.results.length)]
      );
      return req;
      // "https://api.themoviedb.org/3/discover/tv?api_key=${API_KEY}&with_networks=213"
    }
    fetchData();
  }, []);
  //console.log("1111111111111111111", movie);
  function truncate(str, n) {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: `url("https://image.tmdb.org/t/p/original${movie?.backdrop_path}")`,
        backgroundPosition: "center center"
      }}
    >
      <div className="banner__contents">
        {/*　？　多分型をnull許容にしている。　||はor　最初の変数があればそれを出力、以降は無視*/}
        <h1 className="banner__title">
          {movie?.title || movie?.name || movie?.origanl_name}
        </h1>
        <div className="banner__buttons">
          <button className="banner__button">Play</button>
          <button className="banner__button">My List</button>
        </div>
        <h1 className="banner__description">
          {truncate(movie?.overview, 150)}
        </h1>
      </div>
      <div className="banner--fadebutton" />
    </header>
  );
}

export default Banner;
